export type RedirectAfterPost =
  | 'none'
  | 'home'
  | 'community'
  | 'public'
  | 'tag';

// Only the first hashtag is used; a leading '#' and separators are ignored.
export const normalizeRedirectTag = (input: unknown): string => {
  if (typeof input !== 'string') return '';
  return input.split(/[\s#,、，]+/).find((part) => part.length > 0) ?? '';
};

export const redirectPathAfterPost = (
  target: unknown,
  tag: unknown,
): string | null => {
  switch (target) {
    case 'home':
      return '/home';
    case 'community':
      return '/public/local';
    case 'public':
      return '/public';
    case 'tag': {
      const normalized = normalizeRedirectTag(tag);
      return normalized ? `/tags/${encodeURIComponent(normalized)}` : null;
    }
    default:
      return null;
  }
};
